<script setup>
import {onMounted, onUnmounted, reactive, watch} from "vue";
import countdown from '@/StandaloneJS/vue-countdown';
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";
import {activeComponentStore} from "@/Stores/ActiveComponentStore";

const compName = 'TasksPendingExpiredComponent';

const props = defineProps({
  contextSchemaA: String,
  clientId: null
});

const data = reactive(
    {
      search: null,
      dataLoading: true,
      newAdj: false,
      headers: [
        { title: 'Claim Number', key: 'claimnumber' },
        { title: 'Claim Age (Days)', key: 'age' },
        { title: 'Tasks Pending', key: 'description' },
        { title: 'Time Remaining', key: 'timedue' },
        { title: 'Adjuster', key: 'adjuster' },
        { title: 'Client', key: 'clientsname' },
      ],
      items: [],
    }
);

const getData = () => {
  data.dataLoading = true;
  ApiWrapper.post('tasks-pending', 'list-tasks-pending-expired', {
    clientId: props.clientId
  })
      .then((response) => {
        data.items = response.tasks;
        data.dataLoading = false;
      })
      .catch((e)=>{
        ToastUtil.error(e);
        data.dataLoading = false;
      })
}

watch(() => props.clientId, async (val) => {
  getData();
});

onMounted(async()=>{
  let context = props
  if (context.contextSchemaA === 'person') {
    data.headers[0].text = 'Name';
    data.headers[0].value = 'personname';
  } else if (context.contextSchemaA === 'claims') {
    data.headers[0].text = 'Claim Number';
    data.headers[0].value = 'claimnumber';
  } else if (context.contextSchemaA === 'clients') {
    data.headers[0].text = 'Client Name';
    data.headers[0].value = 'clientsname';
  }
  getData();

  activeComponentStore.registerComponent(
      compName,
      [
        'tasks'
      ],
      getData
  );
})

onUnmounted(() => {
  activeComponentStore.deregisterComponent(compName);
});


</script>

<template>
  <v-container  fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Tasks Pending - Expired</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-row>
        <v-col cols="4">
          <v-text-field v-model="data.search" append-inner-icon="mdi-magnify" label="Search" single-line hide-details
                        class="ml-4"></v-text-field>
        </v-col>
        <v-col>
          <v-btn icon variant="flat" class="mt-1" @click="getData()">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table :items="data.items" :headers="data.headers" item-value="tasksid" :search="data.search"
                    :loading="data.dataLoading" loading-text="Loading... Please wait" :items-per-page-options="[10, 50, 200, -1]">
        <template v-slot:[`item.claimnumber`]="{ item }">
          <RouterLink :to="`/claim/${item.claimid}`">
            {{item.claimnumber}}
          </RouterLink>
        </template>
        <template v-slot:[`item.personname`]="{ item }">
          <RouterLink :to="`/userprofile/${item.personid}`">
            {{ item.personname }}
          </RouterLink>
        </template>
        <template v-slot:[`item.clientsname`]="{ item }">
          <RouterLink :to="`/client/${item.clientsid}`">
            {{ item.clientsname }}
          </RouterLink>
        </template>
        <template v-slot:[`item.timedue`]="{ item }">
          <v-chip label v-if="new Date(item.timedue) - new Date() > 0" class="success text--white">
            <v-icon dark left>mdi-calendar</v-icon>
            <countdown :time="new Date(item.timedue) - new Date()">
              <template v-slot="props">
                {{ props.totalHours.toString().padStart(2,0) }}:{{
                  props.minutes.toString().padStart(2,0) }}:{{
                  props.seconds.toString().padStart(2,0) }}
              </template>
            </countdown>
          </v-chip>
          <v-chip label v-else-if="!item.timecompleted" class="error text--white">
            <v-icon dark left>mdi-calendar</v-icon>
            <countdown :time="new Date() - new Date(item.timedue)" :interval="-1000">
              <template v-slot="props">
                {{ props.totalHours.toString().padStart(2,0) }}:{{
                  props.minutes.toString().padStart(2,0) }}:{{
                  props.seconds.toString().padStart(2,0) }}
              </template>
            </countdown>
          </v-chip>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>

</style>